import { createSlice } from '@reduxjs/toolkit';
import { NavType } from '../constants';
import { RequestStatus } from '../interface';
import { isPaidPortalThunk } from '../thunks/is-paid-portal.thunk';
import { getCurrentTrialsThunk } from '../thunks/get-current-trials.thunk';
export const initialState = {
  displayFeedbackModal: undefined,
  isVerticalNavEnabled: false,
  navType: NavType.VERTICAL,
  isInDemoApp: false,
  isNotificationsComponentLoaded: false,
  // TODO: Once we have this rolled out for a bit we want to swap this to false
  // by default but to maintain backwards compatibility for Inbound (and let the
  // BE revert if they need to) we're going to enable Copilot by default if
  // something goes wrong with this new field.
  navExtensionTriggers: {
    copilot: {
      isAccurate: true,
      isEnabled: true
    },
    yearInReview: {
      isAccurate: false,
      isEnabled: false
    },
    hubspotCredits: {
      isAccurate: false,
      isEnabled: false,
      totalCredits: 0,
      creditsUsed: 0
    }
  },
  paidPortal: {
    isPaidPortal: null,
    status: RequestStatus.IDLE
  },
  currentTrials: {
    currentTrials: [],
    status: RequestStatus.IDLE
  }
};
export const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    setDisplayFeedbackModal: (state, action) => {
      state.displayFeedbackModal = action.payload.displayFeedbackModal;
    },
    setIsVerticalNavEnabled: (state, action) => {
      state.isVerticalNavEnabled = action.payload.isVerticalNavEnabled;
    },
    setIsInDemoApp: (state, action) => {
      state.isInDemoApp = action.payload.isInDemoApp;
    },
    setIsNotificationsComponentLoaded: (state, action) => {
      state.isNotificationsComponentLoaded = action.payload.isLoaded;
    }
  },
  extraReducers: builder => {
    builder.addCase(isPaidPortalThunk.pending, state => {
      state.paidPortal.status = RequestStatus.LOADING;
    });
    builder.addCase(isPaidPortalThunk.fulfilled, (state, action) => {
      state.paidPortal.isPaidPortal = action.payload.isPaidPortal;
      state.paidPortal.status = RequestStatus.SUCCESS;
    });
    builder.addCase(isPaidPortalThunk.rejected, state => {
      state.paidPortal.isPaidPortal = false;
      state.paidPortal.status = RequestStatus.ERROR;
    });
    builder.addCase(getCurrentTrialsThunk.pending, state => {
      state.currentTrials.status = RequestStatus.LOADING;
    });
    builder.addCase(getCurrentTrialsThunk.fulfilled, (state, action) => {
      state.currentTrials.currentTrials = action.payload;
      state.currentTrials.status = RequestStatus.SUCCESS;
    });
    builder.addCase(getCurrentTrialsThunk.rejected, (state, action) => {
      state.currentTrials.status = RequestStatus.ERROR;
      state.currentTrials.currentTrials = action.payload;
    });
  }
});
export const getAppConfig = state => state.appConfig;
export const getNotificationsComponentLoadedState = state => state.appConfig.isNotificationsComponentLoaded;
export const {
  setDisplayFeedbackModal,
  setIsVerticalNavEnabled,
  setIsInDemoApp,
  setIsNotificationsComponentLoaded
} = appConfigSlice.actions;
export default appConfigSlice.reducer;